import { useDispatch, useSelector } from 'react-redux';

import './App.css';
import ProductCard from './components/ProductCard';
import CartPage from './page/CartPage';
function App() {

  const {productList,productAdd} = useSelector((state) => state.products);
  const dispatch = useDispatch();

  return (

    <>
    

   <div className="App">
  <div>
  {/* Navbar */}
  <nav className="bg-[#171C2A] py-4">
    <div className="navBar">
      <a href="index.html">
        <img src="./images/logo.png" alt="LWS" className="max-w-[140px]" />
      </a>
      <div className="flex gap-4">
        <a href="#home" className="navHome" id="lws-home"> Home </a>
        <a href="cart.html" className="navCart" id="lws-cart">
          <i className="text-xl fa-sharp fa-solid fa-bag-shopping" />
          <span id="lws-totalCart">0</span>
        </a>
      </div>
    </div>
  </nav>
  {/* Navbar ends */}
  <main className="py-16">
    <div className="productWrapper">
      {/* products container */}
      <div className="productContainer" id="lws-productContainer">
        {/* product item */}
       {productList.map(product=>( <ProductCard product={product} key={product.id} />))}
        {/* product item ends */}
       
      </div>
      {/* products container ends */} 
      <div>
        {/* Product Input Form */}
        <div className="formContainer">
          <h4 className="formTitle">Add New Product</h4>
          <form className="space-y-4 text-[#534F4F]" id="lws-addProductForm" onSubmit={e=>{
            e.preventDefault();
            dispatch({type:"addproduct/list"})
          }} >
            {/* product name */}
            <div className="space-y-2">
              <label htmlFor="name">Product Name</label>
              <input name='name' value={productAdd.name}  onChange={(e)=>dispatch({type:"addproduct/input",payload:e.target})} className="addProductInput" id="lws-inputName" type="text" required />
            </div>
            {/* product category */}
            <div className="space-y-2">
              <label htmlFor="category">Category</label>
              <input  name='category'  value={productAdd.category}   onChange={(e)=>dispatch({type:"addproduct/input",payload:e.target})}  className="addProductInput" id="lws-inputCategory" type="text" required />
            </div>
            {/* product image url */}
            <div className="space-y-2">
              <label htmlFor="image">Image Url</label>
              <input  name='imageurl'  value={productAdd.imageurl}   onChange={(e)=>dispatch({type:"addproduct/input",payload:e.target})}  className="addProductInput" id="lws-inputImage" type="text" required />
            </div>
            {/* price & quantity container */}
            <div className="grid grid-cols-2 gap-8 pb-4">
              {/* price */}
              <div className="space-y-2">
                <label htmlFor="price">Price</label>
                <input  name='price'  value={productAdd.price}    onChange={(e)=>dispatch({type:"addproduct/input",payload:e.target})}  className="addProductInput" type="number" id="lws-inputPrice" required />
              </div>
              {/* quantity */}
              <div className="space-y-2">
                <label htmlFor="quantity">Quantity</label>
                <input  name='quantity'   value={productAdd.quantity}   onChange={(e)=>dispatch({type:"addproduct/input",payload:e.target})}   className="addProductInput" type="number" id="lws-inputQuantity" required />
              </div>
            </div>
            {/* submit button */}
            <button type="submit" id="lws-inputSubmit" className="submit">Add Product</button>
          </form>
        </div>
        {/* Product Input Form Ends */}
      </div>
    </div>
  </main>


  {/* Navbar ends */}
<CartPage />

</div>

    </div>

    </>
  );
}

export default App;
